"use client";

import { useState } from "react";

// Inline TrekkSoft Bookie widget. Loads the booking iframe directly on the
// page so the guest never leaves fb-tt.com. Multi-option mode shows tabs
// at the top of the widget so the guest can switch between (e.g.) Shared
// vs Private without a page reload.
//
// Bookie credentials are the public client + token used by curacao-tours.com
// against the same fbtttravelcuracao TrekkSoft merchant.

const BOOKIE_CLIENT = "BOOKIE-5badffc8663be9c7621fe18cf";
const BOOKIE_TOKEN = "f644f78038045737f3c2da77ea17bf4521b12a1ccdc0aded";

export interface BookieOption {
  id: number;
  label: string;
  sublabel?: string;
}

interface Props {
  options: BookieOption[];
  lang?: string;
  height?: number;
  className?: string;
}

export default function TrekksoftBookie({
  options,
  lang = "en",
  height = 720,
  className = "",
}: Props) {
  const [activeId, setActiveId] = useState(options[0]?.id);
  const [loaded, setLoaded] = useState(false);

  if (!activeId) return null;

  const url = `https://bw.trekksoft.com/views/window.html?type=activity-booking&id=${activeId}&clientId=${BOOKIE_CLIENT}&token=${BOOKIE_TOKEN}&lang=${lang}`;

  return (
    <div
      className={`overflow-hidden rounded-2xl border border-fbtt-orange/20 bg-white shadow-xl ${className}`}
    >
      {options.length > 1 && (
        <div className="flex flex-wrap border-b border-fbtt-gray-light bg-fbtt-cream/40">
          {options.map((opt) => {
            const isActive = opt.id === activeId;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => {
                  setActiveId(opt.id);
                  setLoaded(false);
                }}
                className={`flex-1 min-w-[160px] px-5 py-4 text-left transition-colors ${
                  isActive
                    ? "border-b-2 border-fbtt-orange bg-white"
                    : "hover:bg-white/60"
                }`}
              >
                <div
                  className={`text-sm font-semibold ${
                    isActive ? "text-fbtt-orange" : "text-fbtt-navy"
                  }`}
                >
                  {opt.label}
                </div>
                {opt.sublabel && (
                  <div className="mt-0.5 text-xs text-fbtt-gray">
                    {opt.sublabel}
                  </div>
                )}
              </button>
            );
          })}
        </div>
      )}
      <div className="relative bg-white" style={{ height }}>
        {!loaded && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-fbtt-cream/30">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-fbtt-orange/30 border-t-fbtt-orange" />
            <p className="text-sm text-fbtt-gray">Loading booking widget…</p>
          </div>
        )}
        <iframe
          key={activeId}
          src={url}
          title="TrekkSoft booking"
          loading="lazy"
          allow="payment; fullscreen"
          onLoad={() => setLoaded(true)}
          className="block h-full w-full border-0"
        />
      </div>
    </div>
  );
}
